import styled from 'styled-components'

interface IFilePreviewEmptyStateContainerStyledProps {}

export const FilePreviewEmptyStateContainerStyled = styled.div<IFilePreviewEmptyStateContainerStyledProps>`
  position: absolute;

  top: 1.5rem;
  left: 1.5rem;
  right: 1.5rem;
  bottom: 1.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
`
